import { useQueryClient, useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { shutdownAlisaAudioQuery } from '../../../../shared/api/queries';

const { shutdownAlisaAudioKey } = shutdownAlisaAudioQuery;

const generateAlisaAudio = async ({ shutdownId, text }) => {
  const res = await request.put(
    `/Alert/alisa_generate_audio`,
    {
      alertId: typeof shutdownId === 'string' ? shutdownId : String(shutdownId),
      text,
    },
    'Не удалось сгенерировать аудио',
    'Error'
  );

  return res;
};

export const useGenerateAlisaAudio = (options) => {
  const queryClient = useQueryClient();

  const generateMutation = useMutation(generateAlisaAudio, {
    onSuccess: (data, { shutdownId }) => {
      if (data !== 'Error') {
        queryClient.invalidateQueries(shutdownAlisaAudioKey(shutdownId));
        typeof options?.onSuccess === 'function' && options.onSuccess(data);
      }
    },
  });

  return {
    generateAudio: generateMutation.mutateAsync,
    loading: generateMutation.isLoading,
  };
};
